/**
 * 获取密码强度
 */
export const getStrenth = (strength) => {
  switch (strength) {
        case '1':
          return '非常弱'
        case '2':
          return '弱'
        case '3':
          return '一般'
        case '4':
          return '强'
        case '5':
          return '非常强'
      }
}

/**
 * 设置主题
 */
export const setTheme = (name) => {
  document.body.className = name
}